import React, { Component } from "react";
import * as ErrorAction from "../../../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import Container from "../../../../../modules/commons/Container";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { mapToObjectDDL } from "../../../../common/mapper";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import { monthOptions, yearOptions } from "../../dashboardKacab/config";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import ProspectTodayTab from "./prospectTodayTab";
import { HttpStatus } from "../../../../common/Constants";

class ProspectDaily extends Component {
    constructor(props) {
        super(props);
        this.state = {
          loading: false,
          dataCabang: [],
          dataTL: [],
          kodeCabang: null,
          year: null,
          month: null,
          search: {
            kodeCabang: null,
            teamLead: null,
          },
        };
    };

    componentDidMount = async () => {
        this.fetchDataCabang();
    };

    fetchDataCabang = async () => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
            setError: this.props.setError,
            menuName: "Dashboard Level CRM Salesman CS - Laporan Prospek Daily",
            args: null,
        });
        if (res.ok) {
            let filteredData = res.data.data.filter(
                item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
            );

            if (filteredData.length !== 0) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataCabang: filteredData,
                    kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang)
                }))
                this.fetchDataTL(filteredData[0].kodeCabang)
            }
        }
        this.handleTriggerLoading();
    };


    fetchDataTL = async (data) => {
        const userId = localStorage.getItem("userId");
        let resUser = await Api.create("NAGAMAS_MASTER_DATA").getUserProfile({
          idUser: userId,
        });
        
        try {
            this.handleTriggerLoading();
            let res = await fetchDataAsync({
              asyncFn: Api.create("NAGAMAS_MASTER_DATA").getTLByEmployeeId,
              setError: this.props.setError,
              menuName:
                "Dashboard Level Koordinator- Laporan Prospek Daily",
              args: { employeeId : resUser.data.data.employeeId},
            });
            console.log(res);
            
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTL: [res.data.data], 
                }));
            }
            this.handleTriggerLoading();
        } catch (error) {
            console.log(error);
        }
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({ ...prevValue, loading: !prevValue.loading, }));
    };

    handleSearchValueChange = async (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
        if(name==='kodeCabang' && value){
            this.fetchDataTL(value.value)
        }
    };

    handleSearch = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                kodeCabang: this.state.kodeCabang?.value,
                teamLead: this.state.teamLead?.value
            },
        }));
    };

    resetSearch = () =>{
        this.setState((prev) => ({
          ...prev,
          search: {
            kodeCabang: null,
            teamLead: null,
          },
        }));
    }

    render() {
        return (
          <>
            <Container>
              <FlexView style={{ gap: "20px", alignItems: "center" }}>
                <SimpleDDL
                  id="select_options_kode_cabang"
                  box="search"
                  name="kodeCabang"
                  containerclassname="width width-250px"
                  placeholder="Nama Cabang"
                  menuPosition="fixed"
                  isClearable
                  options={this.state.dataCabang.map((item) =>
                    mapToObjectDDL(item.namaDealer, item.kodeCabang)
                  )}
                  value={this.state.kodeCabang}
                  onChange={(value, { name }) => {
                    this.handleSearchValueChange(name, value)
                    this.handleSearchValueChange("teamLead", null)
                  }}
                />
                <SimpleDDL
                  id="select_options_month"
                  box="search"
                  name="teamLead"
                  isClearable
                  containerclassname="width width-250px"
                  placeholder="Nama TL"
                  menuPosition="fixed"
                  options={this.state.dataTL?.map((item) =>
                    mapToObjectDDL(item.name, item.employeeId)
                  )}
                  value={this.state.teamLead}
                  onChange={(value, { name }) =>
                    this.handleSearchValueChange(name, value)
                  }
                />
                <SimpleButton
                  styles={{ marginBottom: "15px" }}
                  onClick={() => this.handleSearch()}
                >
                  Cari
                </SimpleButton>
              </FlexView>
              <Tabs>
                <TabList>
                  <Tab>Laporan Statistik Prospek Today</Tab>
                  <Tab>Laporan Appointment Follow Up Hari ini</Tab>
                  <Tab>Laporan Appointment Overdue</Tab>
                </TabList>
                <TabPanel>
                  <ProspectTodayTab
                    {...this.props}
                    tab="prospek"
                    search={this.state.search}
                    triggerLoading={this.handleTriggerLoading}
                    resetSearch={this.resetSearch}
                  />
                </TabPanel>
                <TabPanel>
                  <ProspectTodayTab
                    {...this.props}
                    tab="appointmentFU"
                    search={this.state.search}
                    triggerLoading={this.handleTriggerLoading}
                    resetSearch={this.resetSearch}
                  />
                </TabPanel>
                <TabPanel>
                  <ProspectTodayTab
                    {...this.props}
                    tab="appointmentOD"
                    search={this.state.search}
                    triggerLoading={this.handleTriggerLoading}
                    resetSearch={this.resetSearch}
                  />
                </TabPanel>
              </Tabs>
            </Container>
            {this.state.loading && (
              <SimpleLoadingOverlay active={this.state.loading} />
            )}
          </>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ProspectDaily);